import { useCallback, useMemo } from 'react';

import click from '@gojob/tracking/click';

import useOfferListType from 'src/tracking/OfferListTypeProvider/useOfferListType';

const useTrackOffersCtaClick = () => {
  const type = useOfferListType();

  const eventAction = useMemo(() => {
    switch (type) {
      case 'jobboard-nearby-offers':
      case 'jobboard-offer-nearby-offers':
        return 'nearby-offers-click-cta';
      case 'jobboard-similar-offers':
      case 'jobboard-offer-similar-offers':
        return 'similar-offers-click-cta';
      default:
        return;
    }
  }, [type]);

  const eventCategory = useMemo(() => {
    switch (type) {
      case 'jobboard-offer-similar-offers':
      case 'jobboard-offer-nearby-offers':
        return 'offer-jobboard';
      default:
        return 'jobboard';
    }
  }, [type]);

  const trackClick = useCallback(() => {
    if (eventAction) {
      click({
        eventAction,
        eventCategory,
        eventName: 'see-all-offers',
      });
    }
  }, [eventAction]);

  return trackClick;
};

export default useTrackOffersCtaClick;
